export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ASSOCIACAO = 'ASSOCIACAO',
  USUARIO_FINAL = 'USUARIO_FINAL'
}

export type Action = 'criar' | 'ler' | 'atualizar' | 'excluir' | 'gerenciar';

export type Resource = 
  | 'campanhas'
  | 'sorteios'
  | 'premios'
  | 'patrocinadores'
  | 'lojas'
  | 'cupons'
  | 'lotes-cupons'
  | 'relatorios'
  | 'usuarios'
  | 'associacoes'
  | 'planos'
  | 'configuracoes'
  | 'dashboard'
  | 'perfil';

export interface Permission {
  resource: Resource;
  action: Action;
}

export interface RolePermissions {
  role: UserRole;
  permissions: Permission[];
}

export const rolePermissions: RolePermissions[] = [
  {
    role: UserRole.SUPER_ADMIN,
    permissions: [
      { resource: 'usuarios', action: 'criar' },
      { resource: 'usuarios', action: 'ler' },
      { resource: 'usuarios', action: 'atualizar' },
      { resource: 'usuarios', action: 'excluir' },
      { resource: 'associacoes', action: 'criar' },
      { resource: 'associacoes', action: 'ler' },
      { resource: 'associacoes', action: 'atualizar' },
      { resource: 'associacoes', action: 'excluir' },
      { resource: 'campanhas', action: 'criar' },
      { resource: 'campanhas', action: 'ler' },
      { resource: 'campanhas', action: 'atualizar' },
      { resource: 'campanhas', action: 'excluir' },
      { resource: 'planos', action: 'criar' },
      { resource: 'planos', action: 'ler' },
      { resource: 'planos', action: 'atualizar' },
      { resource: 'planos', action: 'excluir' },
      { resource: 'configuracoes', action: 'gerenciar' }
    ]
  },
  {
    role: UserRole.ASSOCIACAO,
    permissions: [
      { resource: 'usuarios', action: 'ler' },
      { resource: 'campanhas', action: 'criar' },
      { resource: 'campanhas', action: 'ler' },
      { resource: 'campanhas', action: 'atualizar' },
      { resource: 'campanhas', action: 'excluir' },
      { resource: 'planos', action: 'ler' }
    ]
  },
  {
    role: UserRole.USUARIO_FINAL,
    permissions: [
      { resource: 'campanhas', action: 'ler' },
      { resource: 'planos', action: 'ler' }
    ]
  }
];

export interface RBACContextType {
  getPermissions: (role: UserRole) => Permission[];
  hasPermission: (resource: Resource, action: Action) => boolean;
  hasAnyRole: (roles: UserRole[]) => boolean;
  hasAnyPermission: (resource: Resource, actions: Action[]) => boolean;
  hasRole: (role: UserRole) => boolean;
  getUserPermissions: () => Permission[];
  canAccess: (resource: Resource, action?: Action) => boolean;
} 